import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import {
  alignCenter,
  base64Image,
  blueAttributeHeadersFill,
  BULK_TEXT_FOR_UPLOAD,
  BULK_TEXT_FOR_VALID_OPTIONS,
  conditionallyRequiredFieldsFill,
  InstructionSheetStyle,
  italic,
  nonEditableFieldsFill,
  optionalFieldFill,
  purpleAttributeHeadersFill,
  redAttributeHeadersFill,
  requiredFieldFill,
  optionsSheetStyle,
  wrapText,
  greyAttributeHeadersFill,
  errorSubCategoryHeadersFill,
} from '../../../constants/bulkExcelConstants'
import { toTitleCase } from '../../../resources/commonUtills'
import { sortBy } from 'lodash'

export const constructInstruction = (workbook) => {
  //Initialize the worksheet
  const InstructionSheet = workbook.addWorksheet('Guide')
  InstructionSheet.protect('', {
    // Don’t allow any edits
    selectLockedCells: false,
    selectUnlockedCells: false,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false,
  })

  //1. Add the logo
  const logoImg = workbook.addImage({
    base64: base64Image,
    extension: 'png',
  })

  InstructionSheet.addImage(logoImg, {
    tl: { col: 1, row: 0.9 },
    ext: { width: 90, height: 90 },
  })

  //Border
  for (let i = 1; i <= 68; i++) {
    const cell = InstructionSheet.getCell(`B${i}`)
    const border = {
      left: { style: 'medium' },
      right: { style: 'medium' },
    }
    if (i === 1) {
      border.top = { style: 'medium' }
    }
    if (i === 68) {
      border.bottom = { style: 'medium' }
    }
    cell.border = border
  }

  //Heading
  InstructionSheet.views = [{ zoomScale: 120 }]
  InstructionSheet.getColumn('B').width = 180 // Set the width of column B (not just B1, but the whole column)
  InstructionSheet.getRow(1).height = 100 // Set the height of row 1 (not just B1, but the whole row)
  InstructionSheet.getCell('B1').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.HEADING
  InstructionSheet.getCell('B1').alignment = alignCenter
  InstructionSheet.getCell('B1').font = InstructionSheetStyle.header.font

  //2. SubHeading 1
  InstructionSheet.getRow(2).height = 20
  InstructionSheet.getCell('B2').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.SUB_HEADING1
  InstructionSheet.getCell('B2').font = InstructionSheetStyle.exportTitle.font
  InstructionSheet.getCell('B2').fill = InstructionSheetStyle.exportTitle.fill

  //3. Content 1
  InstructionSheet.getCell('B3').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE1
  InstructionSheet.getCell('B4').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE1_1
  InstructionSheet.getCell('B5').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE1_2
  InstructionSheet.getCell('B5').style.alignment = wrapText
  InstructionSheet.mergeCells('B5:B6')

  //4. Content 2
  //To make some portion of the text bold
  const richTextValue1 = [
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2 },
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_1,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_2 },
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_3,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_4 },
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_5,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_6 },
  ]
  InstructionSheet.getCell('B8').value = { richText: richTextValue1 }
  InstructionSheet.getCell('B8').style.alignment = wrapText
  InstructionSheet.mergeCells('B8:B12')
  InstructionSheet.getCell('B13').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE2_7
  InstructionSheet.getCell('B13').style.alignment = wrapText
  InstructionSheet.mergeCells('B13:B14')

  //5. SubHeading 2
  InstructionSheet.getRow(16).height = 20
  InstructionSheet.getCell('B16').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.SUB_HEADING2
  InstructionSheet.getCell('B16').font = InstructionSheetStyle.exportTitle.font
  InstructionSheet.getCell('B16').fill = InstructionSheetStyle.exportTitle.fill

  //6. Content 3
  const richTextValue2 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE5,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE5_1 },
  ]
  const richTextValue3 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE6,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE6_1 },
  ]
  InstructionSheet.getCell('B17').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE3
  InstructionSheet.getCell('B18').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE4
  InstructionSheet.getCell('B18').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B19').value = { richText: richTextValue2 }
  InstructionSheet.getCell('B20').value = { richText: richTextValue3 }

  //7. Content 4
  const richTextValue4 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE9,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE9_1 },
  ]
  const richTextValue5 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE10,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE10_1 },
  ]
  const richTextValue6 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE11,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE11_1 },
  ]
  const richTextValue7 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE12,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE12_1 },
  ]
  InstructionSheet.getCell('B22').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE7
  InstructionSheet.getCell('B22').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B23').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE8
  InstructionSheet.getCell('B24').value = { richText: richTextValue4 }
  InstructionSheet.getCell('B24').fill = requiredFieldFill.fill
  InstructionSheet.getCell('B25').value = { richText: richTextValue5 }
  InstructionSheet.getCell('B25').fill = conditionallyRequiredFieldsFill.fill
  InstructionSheet.getCell('B26').value = { richText: richTextValue6 }
  InstructionSheet.getCell('B27').value = { richText: richTextValue7 }
  InstructionSheet.getCell('B27').alignment = wrapText
  InstructionSheet.mergeCells('B27:B28')
  InstructionSheet.getCell('B27').fill = nonEditableFieldsFill.fill
  InstructionSheet.getCell('B28').fill = nonEditableFieldsFill.fill

  //8. Content 5
  InstructionSheet.getCell('B30').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE13
  InstructionSheet.getCell('B31').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE14
  InstructionSheet.getCell('B32').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE15
  InstructionSheet.getCell('B33').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE16

  //9. Content 6
  const richTextValue8 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE18,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE18_1 },
  ]
  const richTextValue9 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE19,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE19_1 },
  ]
  const richTextValue10 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE20,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE20_1 },
  ]
  const richTextValue11 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE21,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE21_1 },
  ]
  InstructionSheet.getCell('B35').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE17
  InstructionSheet.getCell('B36').value = { richText: richTextValue8 }
  InstructionSheet.getCell('B37').value = { richText: richTextValue9 }
  InstructionSheet.getCell('B38').value = { richText: richTextValue10 }
  InstructionSheet.getCell('B39').value = { richText: richTextValue11 }

  //8. SubHeading 3
  InstructionSheet.getRow(41).height = 20
  InstructionSheet.getCell('B41').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.SUB_HEADING3
  InstructionSheet.getCell('B41').font = InstructionSheetStyle.exportTitle.font
  InstructionSheet.getCell('B41').fill = InstructionSheetStyle.exportTitle.fill

  //9. Content 7
  const richTextValue12 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE22,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE22_1 },
  ]
  const richTextValue13 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE23,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE23_1 },
  ]
  const richTextValue14 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE24,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE24_1 },
  ]
  const richTextValue15 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE25,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE25_1 },
  ]
  const richTextValue16 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE26,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE26_1 },
  ]
  InstructionSheet.getCell('B42').value = { richText: richTextValue12 }
  InstructionSheet.getCell('B43').value = { richText: richTextValue13 }
  InstructionSheet.getCell('B44').value = { richText: richTextValue14 }
  InstructionSheet.getCell('B45').value = { richText: richTextValue15 }
  InstructionSheet.getCell('B46').value = { richText: richTextValue16 }

  //10. SubHeading 4
  InstructionSheet.getRow(48).height = 20
  InstructionSheet.getCell('B48').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.SUB_HEADING4
  InstructionSheet.getCell('B48').font = InstructionSheetStyle.exportTitle.font
  InstructionSheet.getCell('B48').fill = InstructionSheetStyle.exportTitle.fill
  const richTextValue17 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE29,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE29_1 },
  ]
  const richTextValue18 = [
    {
      text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE30,
      font: { bold: true },
    },
    { text: BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE30_1 },
  ]
  InstructionSheet.getCell('B49').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE27
  InstructionSheet.getCell('B49').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B50').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE27_1
  InstructionSheet.getCell('B51').value = { richText: richTextValue17 }
  InstructionSheet.getCell('B52').value = { richText: richTextValue18 }
  InstructionSheet.getCell('B53').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE31
  InstructionSheet.getCell('B55').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE32
  InstructionSheet.getCell('B55').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B56').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE32_1
  InstructionSheet.getCell('B57').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE33
  InstructionSheet.getCell('B58').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE34

  //12. Content 9
  InstructionSheet.getCell('B60').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE35
  InstructionSheet.getCell('B60').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B61').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE36
  InstructionSheet.getCell('B62').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE37

  //13. Content 10
  InstructionSheet.getCell('B64').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE38
  InstructionSheet.getCell('B64').fill = InstructionSheetStyle.subheading.fill
  InstructionSheet.getCell('B65').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE39

  //14. SubHeading 5
  InstructionSheet.getRow(67).height = 20
  InstructionSheet.getCell('B67').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.SUB_HEADING5
  InstructionSheet.getCell('B67').font = InstructionSheetStyle.exportTitle.font
  InstructionSheet.getCell('B67').fill = InstructionSheetStyle.exportTitle.fill

  // 15. Content 11
  InstructionSheet.getCell('B68').value =
    BULK_TEXT_FOR_UPLOAD.EXPORT.INSTRUCTION.LINE42

  /***** Merge and make it empty *****/
  const startRow = 1
  const endRow = 100
  const columnLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  columnLetters.forEach((col) => {
    if (col === 'B') return // Skip column B
    InstructionSheet.mergeCells(`${col}${startRow}:${col}${endRow}`)
  })
  /***** Merge and make it empty *****/

  return InstructionSheet
}

/* Function to convert inter to Excel cell position */
const covertToExcelPosition = (num) => {
  const res = String.fromCharCode(65 + (num % 26))
  return num >= 26 ? covertToExcelPosition(Math.floor(num / 26) - 1) + res : res
}

export const flattenObject = (attributeObj) => {
  const flattened = []
  const flattenHelper = (attributeValues) => {
    const flattenedObj = []
    Object.entries(attributeValues).forEach(([, value]) => {
      if (Array.isArray(value)) {
        if (Array.isArray(value[0])) {
          value.forEach((item) => {
            const arrayVal = item.join().split('::')
            if (arrayVal[1]) {
              flattenedObj.push(arrayVal[1].replace(/[\[\]']+/g, '')) //eslint-disable-line
            }
          })
        } else {
          flattenedObj.push(value.join('|')) //Changing the delimeter from ',' to '|' since MTA might contain ',' that might affect upload. So to have consistency in both export and upload
        }
      } else if (typeof value === 'string' && value.includes('\n')) {
        const withBullets = value
          .split('\n') // break into lines
          .filter((line) => line.trim() !== '') // remove empty lines
          .map((line) => `• ${line.trim()}`) // add bullet
          .join('\n') // rebuild
        flattenedObj.push(withBullets)
      } else {
        flattenedObj.push(value)
      }
    })
    flattened.push(flattenedObj)
  }
  attributeObj.forEach((item) => {
    flattenHelper(item)
  })

  return flattened
}

export const applyColumnFilter = async (worksheet, subCatStart, sheetData) => {
  const lastRow = worksheet.rowCount
  const lastColumn = sheetData.attributeName.length
  worksheet.autoFilter = {
    from: `A${subCatStart + 3}`, //To ignore field mode and hint text rows while applying filter
    to: {
      row: lastRow,
      column: lastColumn,
    },
  }
}

export const createAttributeGroups = (attributeNameArray, lovData) => {
  const singleSelectAttributes = {}
  const multiSelectAttributes = {}

  const attributesById = {}
  attributeNameArray?.forEach((attr) => {
    attributesById[attr.attributeId] = attr
  })

  const lovDetails = lovData

  for (const rawKey in lovDetails) {
    const parts = rawKey.split('|')
    let attributeId = parts[0]

    let isUdaUom = attributeId?.includes('udauom-')

    // Remove prefix like 'uda-' and not for 'udauom-' since we have to map the UOMs here and we get same attribute as of lov from bulk endpoint
    if (!isUdaUom) {
      attributeId = attributeId?.replace(/^.*-/, '')
    }

    // Try to find attribute metadata
    let attributeMeta = attributesById[attributeId]

    // If not found, try rawKey directly (for things like "brands", "vendor")
    if (!attributeMeta) {
      attributeMeta = attributeNameArray?.find(
        (attr) => attr.attributeId === rawKey,
      )
    }

    if (!attributeMeta) continue

    // Skip if not editable
    if (attributeMeta?.attributeAccessLevel === 'Do not edit') continue

    // Build key: vendor|Vendor or 107882|Product Height
    const finalKey = `${attributeId}|${attributeMeta?.attributeDisplayName}`

    if (attributeMeta.componentType === 'singleSelection') {
      singleSelectAttributes[finalKey] = lovDetails[rawKey]
    } else if (attributeMeta?.componentType === 'multiSelection') {
      multiSelectAttributes[finalKey] = lovDetails[rawKey]
    }
  }
  return { singleSelectAttributes, multiSelectAttributes }
}

const constructExcelDataMultiSheet = async (
  workbook,
  data,
  purpose,
  singleSelectAttributes,
  exportType,
) => {
  const catStart = 1 // Start position for category
  const subCatStart = 2 // Start position for sub category
  data.forEach((sheetData) => {
    let sheetName =
      exportType !== 'rejected_items'
        ? `${sheetData?.itemType.split('-')[0]}`
        : `${sheetData?.itemType.split('-')[0]}_Rejected Items`
    sheetName = sheetName?.substring(0, 31) // since we have a restriction of 31 characters for sheet names in Excel
    const dataSheet = workbook.addWorksheet(toTitleCase(sheetName), {
      properties: {
        defaultColWidth: 20,
      },
      views: [
        {
          state: 'frozen',
          xSplit: exportType === 'rejected_items' ? 5 : 3,
          ySplit: 5,
          zoomScale: 120,
          activeCell: 'D1:L1', // Point the cursor
        },
      ],
    })

    // bump only column E when exporting rejected items
    if (exportType === 'rejected_items') {
      dataSheet.getColumn(4).width = 10
      dataSheet.getColumn(5).width = 40
    }
    if (purpose === 'readOnly') {
      dataSheet.protect('', {
        // Don’t allow any edits
        selectLockedCells: false,
        selectUnlockedCells: false,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: false,
        autoFilter: false,
        pivotTables: false,
      })
    }
    dataSheet.getRow(1).height = 25
    dataSheet.getRow(2).height = 25

    //Field mode is required to determine the color of each cell in different rows
    const wrappedFieldMode = [
      sheetData.attributeName.map((eachAttribute) =>
        eachAttribute?.attributeAccessLevel
          ? eachAttribute?.attributeAccessLevel
          : '',
      ),
    ]

    const attributeHeader = [
      sheetData.attributeName.map((row) => row.attributeDisplayName),
    ]

    //1. Iterate categories
    sheetData?.categoriesObj?.forEach((category, index) => {
      const catCellStart = covertToExcelPosition(category.start)
      const catCellEnd = covertToExcelPosition(category.end)
      const catCell = `${catCellStart}${catStart}:${catCellEnd}${catStart}`
      dataSheet.mergeCells(catCell)

      // Extract top-left cell (e.g., 'A1' from 'A1:C1') for borders
      const topLeftCell = catCell.split(':')[0]
      const cell = dataSheet.getCell(topLeftCell)
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }

      const getCell = dataSheet.getCell(
        `${covertToExcelPosition(category.start + 1)}${catStart}`,
      )
      getCell.value = category.displayName
      getCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'F1EFEC' },
      }
      getCell.font = {
        size: 12,
        color: { argb: 'FF000000' },
      }
      getCell.value = getCell.value.split('_').join(' ')
      getCell.value = getCell.value.toUpperCase()
    })

    //2. Iterate Sub categories
    sheetData?.subCategoriesObj?.forEach((subCategory, index) => {
      const subCatCellStart = covertToExcelPosition(subCategory.start)
      const subCatCellEnd = covertToExcelPosition(subCategory.end)
      const subCatCell = `${subCatCellStart}${subCatStart}:${subCatCellEnd}${subCatStart}`
      dataSheet.mergeCells(subCatCell)

      // Extract top-left cell (e.g., 'A1' from 'A1:C1') for borders
      const topLeftCell = subCatCell.split(':')[0]
      const cell = dataSheet.getCell(topLeftCell)
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }

      const getCell = dataSheet.getCell(`${subCatCellStart}${subCatStart}`)
      getCell.value = subCategory.displayName
      getCell.font = { size: 12, bold: false }
      if (getCell.value.toUpperCase().includes('ERROR')) {
        getCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          ...errorSubCategoryHeadersFill.fill,
        }
      } else {
        getCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'F1EFEC' },
        }
      }
    })

    //3. Add the row with attribute header
    attributeHeader.forEach((row) => {
      const addedRow = dataSheet.addRow(row)
      addedRow.eachCell((cell, col) => {
        const value = cell.value
        const fieldMode = wrappedFieldMode[0][col - 1]
        if (value) {
          if (value.toUpperCase().includes('ERROR')) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              ...redAttributeHeadersFill.fill,
            }
          } else if (
            fieldMode === 'Do not edit' &&
            !value.toUpperCase().includes('ERROR')
          ) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              ...greyAttributeHeadersFill.fill,
            }
          } else if (fieldMode === 'Required') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              ...blueAttributeHeadersFill.fill,
            }
          } else if (fieldMode === 'Conditionally Required') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              ...purpleAttributeHeadersFill.fill,
            }
          }
        }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
        cell.font = { size: 12, bold: true }
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
      })
    })

    //4. Field mode
    wrappedFieldMode.forEach((row) => {
      const addedRow = dataSheet.addRow(row)
      addedRow.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
        cell.font = { size: 10, bold: false, ...italic }
        cell.alignment = wrapText
        if (cell.value === 'Required') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...requiredFieldFill.fill,
          }
        } else if (cell.value === 'Do not edit') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...nonEditableFieldsFill.fill,
          }
        } else if (cell.value === 'Conditionally Required') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...conditionallyRequiredFieldsFill.fill,
          }
        } else {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...optionalFieldFill.fill,
          }
        }
      })
    })

    //5. Row with hint text if any
    const hintText = []
    sheetData?.attributeName?.map((eachAttribute) =>
      hintText.push(eachAttribute.hintText ? eachAttribute.hintText : ''),
    )
    const wrappedHintText = [hintText]
    wrappedHintText.forEach((row, index) => {
      const addedRow = dataSheet.addRow(row)
      addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const cellValue = cell.value?.toString().trim()
        cell.font = {
          ...italic,
          size: 10,
          bold: false,
        }
        cell.alignment = {
          wrapText: true,
          vertical: 'top',
        }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
        const fieldValue = wrappedFieldMode[index][colNumber - 1]
        if (fieldValue === 'Required') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...requiredFieldFill.fill,
          }
        } else if (fieldValue === 'Do not edit') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...nonEditableFieldsFill.fill,
          }
        } else if (fieldValue === 'Conditionally Required') {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...conditionallyRequiredFieldsFill.fill,
          }
        } else {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            ...optionalFieldFill.fill,
          }
        }

        // Set column width ONLY if the cell has a non-empty value
        if (cellValue) {
          const estimatedWidth = Math.max(
            10,
            Math.min(cellValue.length + 2, 50),
          ) // ensure ≥ 10 chars width, ≤ 50
          dataSheet.getColumn(colNumber).width = estimatedWidth
        }
      })
    })

    if (purpose !== 'readOnly') {
      //6. Add the row with attribute Value
      const rows = flattenObject(sheetData.attributeValues)
      rows.forEach((row) => {
        const addedRow = dataSheet.addRow(row)
        addedRow.eachCell((cell) => {
          cell.font = {
            size: 10,
            bold: false,
          }
        })
      })
      // Creating a hidden dropdown list since Excel resticts the number of characters in a cell to 255
      const dropdownSheet = workbook.addWorksheet('DropdownData')
      dropdownSheet.state = 'veryHidden'

      let currentDropdownColumnIndex = 0 // Start from column A (0 index)

      attributeHeader[0]?.forEach((headerTitle, column) => {
        const matchedKey =
          singleSelectAttributes &&
          Object.keys(singleSelectAttributes).find((key) => {
            const displayName = key.split('|')[1]?.trim()
            return displayName === headerTitle
          })
        if (matchedKey) {
          const dropdownOptions = singleSelectAttributes[matchedKey].map(
            (opt) => opt.name,
          )
          const colLetter = covertToExcelPosition(currentDropdownColumnIndex) // Get excel column letter
          if (dropdownOptions.length > 0) {
            dropdownOptions.forEach((val, idx) => {
              dropdownSheet.getCell(`${colLetter}${idx + 1}`).value = val
            })
            for (
              let rowNum = 6; // Start from row 6 to leave space for headers
              rowNum < sheetData.attributeValues.length + 6;
              rowNum++
            ) {
              const cellAddress = { row: rowNum, col: column + 1 }
              const cell = dataSheet.getCell(cellAddress.row, cellAddress.col)
              const validationRange = `DropdownData!$${colLetter}$1:$${colLetter}$${dropdownOptions.length}`

              cell.dataValidation = {
                type: 'list',
                allowBlank: true,
                formulae: [validationRange], // Excel string list
                showErrorMessage: true,
                errorStyle: 'warning',
                errorTitle: 'Invalid Selection',
                error: `Please select a value from the dropdown for ${headerTitle}`,
              }
            }
          }
        }
        currentDropdownColumnIndex++
      })
    }

    // Loop through all rows and set wrap text
    dataSheet.eachRow((row, rowNumber) => {
      if (rowNumber > subCatStart) {
        row.alignment = wrapText
      }
    })
    applyColumnFilter(dataSheet, subCatStart, sheetData)
  })
}

const constructValidOptionsSheet = async (workbook, multiSelectAttributes) => {
  const validOptionsSheet = workbook.addWorksheet('Multi-values Reference', {
    properties: {
      defaultColWidth: 35,
    },
    views: [
      {
        state: 'frozen',
        ySplit: 3,
        zoomScale: 120,
      },
    ],
  })

  //This sheet should have only copy permissions. No edits, no deletes, no inserts
  validOptionsSheet.protect('', {
    // Don’t allow any edits but allow copy
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false,
  })

  //1. Hint text
  validOptionsSheet.getCell('A1').value =
    BULK_TEXT_FOR_VALID_OPTIONS.EXPORT.HINT_TEXT
  validOptionsSheet.mergeCells('A1:D1')
  validOptionsSheet.getCell('A1').font = {
    size: 12,
    ...italic,
  }

  //2. Sort the values of multiSelectAttributes by the attribute name (second part of the key)
  const sortedMultiSelectAttributes = Object.fromEntries(
    sortBy(
      multiSelectAttributes && Object.entries(multiSelectAttributes),
      ([key]) => key.split('|')[1]?.trim().toLowerCase(),
    ),
  )

  //3. Extract headers and value arrays
  const columnHeaders =
    sortedMultiSelectAttributes &&
    Object.keys(sortedMultiSelectAttributes)?.map((eachKey) =>
      toTitleCase(eachKey.split('|')[1]),
    )
  const columns =
    sortedMultiSelectAttributes &&
    Object.values(sortedMultiSelectAttributes)?.map((item) =>
      item.map((opt) => toTitleCase(opt.name)),
    )

  //4. Determine the max number of rows needed
  const maxRows = columns && Math.max(...columns.map((col) => col.length))

  //5. Prepare rows with undefined cells padded
  //Each row pulls one value from each column array by index rowIndex
  const rows = Array.from({ length: maxRows }, (_, rowIndex) => [
    rowIndex === 0 ? BULK_TEXT_FOR_VALID_OPTIONS.EXPORT.HEADING.HEADING_2 : ' ',
    ...columns.map((col) => col[rowIndex] || ''),
  ])

  const headers = [
    BULK_TEXT_FOR_VALID_OPTIONS.EXPORT.HEADING.HEADING_1,
    ...(Array.isArray(columnHeaders) ? columnHeaders : []),
  ]

  //6. Push the headers to a single row
  validOptionsSheet.addRow([]) //To leave a row empty before the headers
  const attributeName = validOptionsSheet.addRow(headers)
  attributeName.eachCell((cell) => {
    cell.font = optionsSheetStyle.header.font
    cell.fill = optionsSheetStyle.header.fill
  })

  //7. Push the values to successive rows
  rows.forEach((row) => {
    validOptionsSheet.addRow(row)
  })

  validOptionsSheet.getCell('A3').font = {
    ...optionsSheetStyle.header.font,
    italic: true,
  }
  validOptionsSheet.getCell('A4').font = { italic: true }

  return validOptionsSheet
}

// TODO: We should get the conditional requirements from the API instead of hardcoding them for consistency

export const generateExportExcel = async (
  itemData,
  optionsData,
  fileName,
  purpose,
  exportType,
) => {
  let downloaded
  const data = itemData
  const { singleSelectAttributes, multiSelectAttributes } = optionsData
  const workbook = new ExcelJS.Workbook()
  workbook.category = 'LaunchPad'
  workbook.lastModifiedBy = `LaunchPad`
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 37000,
      height: 20000,
      firstSheet: 0,
      activeTab: 0,
      visibility: 'visible',
    },
  ]
  // Guide, and Multi-reference sheets will be added only if the purpose is not readOnly or if we are exporting rejected items for re-upload
  if (purpose !== 'readOnly' || exportType === 'rejected_items') {
    constructInstruction(workbook, false)
  }
  await constructExcelDataMultiSheet(
    workbook,
    data,
    purpose,
    singleSelectAttributes,
    exportType,
  )
  if (purpose !== 'readOnly' || exportType === 'rejected_items') {
    await constructValidOptionsSheet(workbook, multiSelectAttributes)
  }

  await workbook.xlsx
    .writeBuffer()
    .then((buffer) => {
      saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        `${fileName}.xlsx`,
      )
      downloaded = 'success'
    })
    .catch((err) => {
      downloaded = 'failed'
    })
  return downloaded
}
